export default __webpack_public_path__ + "images/models/d5b1902312d0f703e3d0a46136a44834.usdz";